module.exports = __webpack_public_path__ + "static/media/tw.24048ed0.svg";